var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, toJS, observe } from "mobx";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import { deepMerge } from "sb-helpers";
export class EventRetriever {
    constructor(props) {
        this.onActivate = () => {
            this.sportResponseDisposer = observe(this.sportConnection, "sportResponse", (change) => this.onUpdate(change.newValue));
            this.attachListeners();
            this.executeRequesters();
        };
        this.onDeactivate = () => {
            this.sportResponseDisposer();
            this.detachListeners();
            this.event = {};
            this.sportConnection.deactivate();
        };
        this.updateEvent = (eventChange) => {
            this.sportConnection.updateQuery(eventChange.eventId);
        };
        this.event = {};
        this.activationManager = props.activationManager;
        this.sportConnection = props.sportConnection;
        this.messageBus = props.messageBus;
    }
    activate(blockId) {
        this.activationManager.activate(blockId, this.onActivate);
    }
    deactivate(blockId) {
        this.activationManager.deactivate(blockId, this.onDeactivate);
    }
    onUpdate(payload) {
        if ("updateType" in payload) {
            this.onPushResponse(payload);
        }
        else {
            this.onPullResponse(payload);
        }
    }
    onUpdateEvent(message) {
        this.updateEvent(message.data[0]);
    }
    attachListeners() {
        this.messageBus.on(InternalMessageBusChannels.legacy.event.update, this.onUpdateEvent, this);
    }
    detachListeners() {
        this.messageBus.off(InternalMessageBusChannels.legacy.event.update, this.onUpdateEvent, this);
    }
    executeRequesters() {
        this.messageBus.emit(InternalMessageBusChannels.legacy.event.request, { callback: this.updateEvent });
    }
    onPushResponse(data) {
        const handlerName = data.updateType.toLowerCase();
        this[handlerName](data.payload["events"]);
    }
    onPullResponse(data) {
        if (data.events.length > 0) {
            this.event = data.events[0];
        }
    }
    add(events) {
        events.length > 0 && (this.event = events[0]);
    }
    change(events) {
        events.length > 0 && (this.event = deepMerge(toJS(this.event), events[0]));
    }
    delete() {
        // TODO: apply logic for markets once marketboard is migrated
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], EventRetriever.prototype, "event", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], EventRetriever.prototype, "onDeactivate", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], EventRetriever.prototype, "onPullResponse", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], EventRetriever.prototype, "add", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], EventRetriever.prototype, "change", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EventRetriever.prototype, "delete", null);
//# sourceMappingURL=EventRetriever.js.map